module.exports = __webpack_public_path__ + "img/auth_step_2.fec07f03.png";